import { Injectable } from '@angular/core';
import { Venue } from '../../models/venue/venue';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../configurations/configuration';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class VenueService {
  venueURL: string;
  constructor(private http: HttpClient) {
    this.venueURL = environment.baseURI + environment.apiUrl + 'venue/list';
  }

  getAllVenue(filterObj, limit, start): Observable<Venue> {
    return this.http.get<Venue>(this.venueURL + "?filter=" + encodeURIComponent(JSON.stringify(filterObj)) + "&limit=" + limit + "&start=" + start);
  }
}
